const brands = {
  repairnest: {
    key: "repairnest",
    name: "RepairNest",
    portalOrigin: "https://admin.repairnestpos.com",
    appId: "com.repairnestpos.backoffice",
    deepLinkScheme: "repairnest",
  },
  storesync: {
    key: "storesync",
    name: "StoreSync POS",
    portalOrigin: "https://admin.storesyncpos.com",
    appId: "com.storesyncpos.backoffice",
    deepLinkScheme: "storesync",
  },
  autorepairdesk: {
    key: "autorepairdesk",
    name: "Auto Repair Desk",
    portalOrigin: "https://admin.autorepairdesk.com",
    appId: "com.autorepairdesk.backoffice",
    deepLinkScheme: "autorepairdesk",
  },
};

export function getMobileBrand() {
  const requested = String(process.env.VUE_APP_MOBILE_BRAND || "repairnest").toLowerCase();
  return brands[requested] || brands.repairnest;
}

export const mobileBrand = getMobileBrand();
